import React from "react";
import Card from "../../../../core/Card";
import Typography from "../../../../core/Typography";
import Button from "../../../../core/Button";
import Input from "../../../../core/Inputs/DefaultInput";
import { useDevice } from "../../../customHooks";
import { useEffect, useRef, useState } from "react";
import style from "../../../style.module.css";
import { Link } from "react-router-dom";
import Title from "../Title";
import Axios from "axios";
import { toast } from "react-toastify";

// import Header from "../../survey/survey-form/landing-page/widgets/Header";
import Svg from "../../../../component/Svg";

export const ForgotPassword = () => {
  let device = useDevice();
  const [isOpen, setOpen] = useState(false);
  const inputRef = useRef();
  const [count, setCount] = useState(0);
  const [isChecked, setChecked] = useState(false);

  const [email, setEmail] = useState('')

  //posting Logon Details
  // const sendOtp = () => {
  //   Axios.post(process.env.REACT_APP_NODE_API_URL+"/users/forgetPasswordOtpSend", {
  //     email: email,
  //   }).then((response) => {
  //     // console.log (response.data)
  //     if (response.data.response == 200) {
  //       alert("OTP Send Successfully");
  //        window.location = '/ForgetPasswordConfirmation/?email='+email;
  //     } else {
  //       alert("Try Again, and verify Email Address!");
  //     }
  //   });
  // };

  const sendOtp = () => {
    if(email == ''){
      toast.error("Please enter email address.");
      return;
    }
    Axios.post(process.env.REACT_APP_NODE_API_URL + "/users/forgetPasswordOtpSend", {
    // Axios.post(process.env.REACT_APP_NODE_API_URL + "/users/resend-otp", {
      email: email, 
    }).then((response) => {
      //console.log(response.data)
      if (response.data.statusCode == 200) {
        window.location = '/admin/forgot-password/confirmation/?email=' + email;
      } else if (response.data.statusCode == 400) { 
        toast.error("OTP not generated.");
      } else if (response.data.statusCode == 202) { 
        toast.error("Your account is not active.");
      } else if (response.data.statusCode == 401) { 
        toast.error("Invalid email.");
      }
    });
  };

  useEffect(() => {
    const str = String(inputRef?.current?.props.value)?.length;
    setCount(str);
  }, []);

  const handleCount = e => {
    setCount(String(e.target.value).length);
  };
  return (
    <>
      <div className='d-flex flex-column site-main-wrapper login-page'>

        <div className="flex-grow-1 main-content-wrap d-flex align-items-center justify-content-center">
          <div className="container">
            <div className="form-outer-wrapper">
              <div className="logo-wrap text-center">
                <Link to="/#0t" className='home-logo'>
                  <Svg name="logo" />
                </Link>
              </div>
              <div className="form-wrapper">
                <div className="form-heading text-center">
                  <h3>Let us know it’s you</h3>
                  <p>Enter your email and we'll send you instructions to reset your password</p>
                </div>
                <div className="field-wrapper">
                  <div className="mb__20 position-relative"> {/* Add Class error to this div once error occurs and if its valid, add class success*/}
                    < Input
                      ref={inputRef}
                      type='text'
                      view='outlined'
                      dense={false}
                      color='default'
                      label=''
                      placeholder='Enter email address...'
                      clearButton={true}
                      success={false}
                      error={false}
                      fill={true}
                      errorHelperText={null}
                      className={"formsinput"}
                      value={email}
                      name="email"
                      onInput={e => setEmail(e.target.value)}
                    />
                  </div>


                </div>
                <div className="button-wrap">
                  <Button className={"formsbutton btn btn-primary"}
                    type="default"
                    view="filled"
                    color="primary"
                    text="Reset Password"
                    fill={true}
                    // onClick={() => setOpen(true)}
                    onClick={sendOtp}
                  />
                </div>
                <div className="form-text text-center">
                  <p><Link to="/">Back to login? </Link></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
